import {createAction} from "@reduxjs/toolkit";
import * as types from "../constants/ActionTypes";

export const fetchCallCenterIvsVin = createAction(types.FETCH_CALL_CENTER_IVS_VIN);
export const fetchCallCenterIvsVinSuccess = createAction(types.FETCH_CALL_CENTER_IVS_VIN_SUCCESS);
export const fetchCallCenterIvsVinFailure = createAction(types.FETCH_CALL_CENTER_IVS_VIN_FAILURE);

export const fetchVehicleProperties = createAction(types.FETCH_CALL_CENTER_VEHICLE_PROPERTIES);
export const fetchVehiclePropertiesSuccess = createAction(types.FETCH_CALL_CENTER_VEHICLE_PROPERTIES_SUCCESS);
export const fetchVehiclePropertiesFailure = createAction(types.FETCH_CALL_CENTER_VEHICLE_PROPERTIES_FAILURE);

export const fetchCustomer = createAction(types.FETCH_CUSTOMER_INFORMATION);
export const fetchCustomerSuccess = createAction(types.FETCH_CUSTOMER_INFORMATION_SUCCESS);
export const fetchCustomerFailure = createAction(types.FETCH_CUSTOMER_INFORMATION_FAILURE);
